import { render, staticRenderFns } from "./UpdateCompanion.vue?vue&type=template&id=c5a296fe&scoped=true"
import script from "./UpdateCompanion.vue?vue&type=script&lang=js"
export * from "./UpdateCompanion.vue?vue&type=script&lang=js"
import style0 from "./UpdateCompanion.vue?vue&type=style&index=0&id=c5a296fe&prod&scoped=true&lang=css"
import style1 from "./UpdateCompanion.vue?vue&type=style&index=1&id=c5a296fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a296fe",
  null
  
)

export default component.exports